export { HTTPDataSvc } from './services/httpdatasvc';
//# sourceMappingURL=index.js.map